module.exports = __webpack_public_path__ + "static/media/art-enthusiast-survey.01fc4aed.svg";